module.exports = __webpack_public_path__ + "static/media/nature.87a730d7.svg";